<app-header sectionName="Login Info">
  <button mat-icon-button (click)="refreshList()" matTooltip="Refresh">
    <mat-icon>refresh</mat-icon>
  </button>
  @if (canAddToStocks) {
  <button mat-stroked-button (click)="openImportDialog()">
    <mat-icon>upload</mat-icon>
    {{ importButtonText }}
  </button>
  }
  @if (canEdit) {
  <button mat-flat-button (click)="openCreateDialog()">
    <mat-icon>add</mat-icon>
    Add Login Info
  </button>
  }
</app-header>

<main class="page">
  <div class="list-toolbar">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-wide">
      <mat-label>Search by email</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()" placeholder="Email">
      @if (searchQuery) {
      <button mat-icon-button matSuffix (click)="clearSearch()" matTooltip="Clear search">
        <mat-icon>close</mat-icon>
      </button>
      }
    </mat-form-field>
  </div>

  <div class="table-card">
    @if (loading && !loginInfos.length) {
    <div class="table-state">
      <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
      Loading login info…
    </div>
    } @else {
    <div class="table-scroll">
    <table mat-table [dataSource]="loginInfos">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox [(ngModel)]="selectAll" (change)="toggleSelectAll()"
            [indeterminate]="selectedCount > 0 && !selectAll">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let info">
          <mat-checkbox [checked]="isSelected(info.email)" (change)="toggleSelection(info.email)"
            (click)="$event.stopPropagation()">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let info" (click)="showRelatedStocks(info)">
          <div class="clickable-cell">
            <span matTooltip="Click to view related stocks">
              {{ info.email }}
            </span>
            @if (info.has_cookies) {
            <mat-icon class="cookies-icon" matTooltip="Has saved session cookies">cookie</mat-icon>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>Created At</th>
        <td mat-cell *matCellDef="let info">{{ info.created_at | date:'short' }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let info">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @if (canViewStocks) {
            <button mat-menu-item (click)="showRelatedStocks(info)">
              <mat-icon>inventory_2</mat-icon>
              <span>View Related Stocks</span>
            </button>
            }
            @if (canAddToStocks) {
            <button mat-menu-item (click)="importSingleToStocks(info)">
              <mat-icon>upload</mat-icon>
              <span>Import to Stocks</span>
            </button>
            }
            @if (canEdit) {
            <button mat-menu-item (click)="openEditDialog(info)">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <button mat-menu-item (click)="deleteLoginInfo(info)" class="danger">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
            }
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </div>

    @if (loginInfos.length === 0) {
    <div class="table-state">
      <mat-icon>inbox</mat-icon>
      {{ searchQuery ? 'No login info matches this search.' : 'No login info yet.' }}
    </div>
    }

    <mat-paginator [length]="totalRecords" [pageIndex]="pageIndex" [pageSize]="pageSize"
      [pageSizeOptions]="[25, 50, 100]" (page)="onPage($event)">
    </mat-paginator>
    }
  </div>
</main>
